module.exports = __webpack_public_path__ + "static/media/logo.eb03420d.png";